import { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Label } from './ui/label';
import { AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Login = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        password: password.trim(),
      });
      const { access_token } = response.data;
      localStorage.setItem('auth_token', access_token);
      toast.success('Access granted!');
      onLogin(access_token);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Incorrect password. Please try again.';
      setError(msg);
      toast.error('Incorrect password');
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="space-y-1 text-center" style={{ backgroundColor: '#A8A67A' }}>
          <div className="flex justify-center mb-3">
            <img
              src="/ellerston-logo.png"
              alt="Ellerston Capital"
              className="h-14 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
          <CardTitle className="text-3xl font-bold text-white">
            Report Generator
          </CardTitle>
          <CardDescription className="text-white opacity-90 text-base">
            Secure Access
          </CardDescription>
        </CardHeader>
        <CardContent className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="password" className="text-base font-semibold">
                Enter Password
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-12 text-base"
                autoFocus
                required
                data-testid="login-password-input"
              />
              {error && (
                <div className="flex items-center gap-2 text-red-600 text-sm mt-2">
                  <AlertCircle className="w-4 h-4" />
                  <span data-testid="login-error-message">{error}</span>
                </div>
              )}
            </div>

            <Button
              type="submit"
              className="w-full h-12 text-base"
              disabled={loading || !password}
              style={{ backgroundColor: '#A8A67A' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#98966a'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#A8A67A'}
              data-testid="login-submit-button"
            >
              {loading ? 'Verifying...' : 'Access Reports'}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-slate-600">
            <p>Proof of Concept (POC) for Ellerston Capital</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
